/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { ServiceInfo } from '../models/service-info';

/**
 * Returns metadata about the SIP connections
 */
@Injectable({
  providedIn: 'root',
})
class ServiceInfoService extends __BaseService {
  static readonly getServiceInfoPath = '/service-info';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Return the media services metadata
   * @return Ok
   */
  getServiceInfoResponse(): __Observable<__StrictHttpResponse<ServiceInfo>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/service-info`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ServiceInfo>;
      })
    );
  }
  /**
   * Return the media services metadata
   * @return Ok
   */
  getServiceInfo(): __Observable<ServiceInfo> {
    return this.getServiceInfoResponse().pipe(
      __map(_r => _r.body as ServiceInfo)
    );
  }
}

module ServiceInfoService {
}

export { ServiceInfoService }
